export default __webpack_public_path__ + "static/media/air_jordan_product_page.30d555b9.png";